import { render, staticRenderFns } from "./OtherLoanStatusListing.vue?vue&type=template&id=06aea763"
import script from "./OtherLoanStatusListing.vue?vue&type=script&lang=js"
export * from "./OtherLoanStatusListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports